import styled from 'styled-components';
import { beam } from '@styles/colors/themes';

interface SearchProps {
  haveResults?: boolean;
}
export const Container = styled.div<SearchProps>`
  display: flex;
  flex-direction: column;
  max-height: 200px;
  overflow-y: auto;
`;

export const Title = styled.div`
  font-size: 24px;
  color: #1a1b1c;
`;

export const Head = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const WarningText = styled.h2`
  font-style: normal;
  display: flex;
  flex-direction: row;
  font-weight: normal;
  font-size: 14px;

  color: ${beam.font.error};
`;
export const Text = styled(WarningText)`
  color: ${beam.font.primary};
  width: fit-content;
  white-space: nowrap;
  margin-left: 8px;
`;
export const ButtonText = styled(WarningText)`
  color: ${beam.font.link};
  margin-left: 14px;
  cursor: pointer;
`;
export const WarningBoldText = styled(WarningText)`
  font-weight: bold;
`;
export const HeadRight = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  justify-content: flex-end;
`;
export const HeadLeft = styled(HeadRight)`
  justify-content: flex-start;
`;
export const Button = styled.button`
  background: #1371fe;
  color: #fff;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.161);
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 8px;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  margin-left: 24px;
  :disabled {
    opacity: 0.3;
  }
`;
export const Icon = styled.img`
  margin-right: 8px;
`;

export const SearchContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  flex: 1;
  margin-bottom: 8px;
`;

export const Search = styled.input<SearchProps>`
  width: 100%;
  border-radius: ${({ haveResults }) => (haveResults ? '8px 8px 0 0' : '8px')};
  font-size: 14px;
  color: ${beam.font.primary};
  align-items: start;
  padding: 10px 12px 10px 16px;
  border-bottom: ${({ haveResults }) =>
    haveResults ? 'none' : '1px solid #e9edf1'};
  box-sizing: border-box;
  display: flex;
  justify-items: center;
  cursor: auto;
  ///
  flex-direction: row;
  gap: 8px;

  height: 42px;

  /* Neutral/N400 (Borders) */
  border: 1px solid #d8dae5;
  /* borders/light-border */
  flex: 1;
  padding-left: 31px;
  -webkit-appearance: none;
  ::placeholder {
    color: #787878;
  }
  :disabled {
    cursor: default;
  }
`;

export const SearchImg = styled.img`
  position: absolute;
  left: 12px;
  z-index: 2;
`;

export const Line = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

export const Count = styled.div`
  color: #1a1b1c;
  margin-left: 16px;
`;
export const SearchButton = styled.h1`
  color: ${beam.color.primaryBlue};
  right: 11px;
  position: absolute;
  font-weight: 500;
  font-style: normal;
  font-size: 12px;
  cursor: pointer;
  margin-bottom: 0;
`;
export const Close = styled.img`
  cursor: pointer;
  margin-left: -21px;
  margin-right: 7px;
`;
export const LoadingImg = styled.img`
  height: 20px;
  width: 20px;
  position: absolute;
  right: 11px;
`;

export const StyledOption = styled.text`
  display: flex;
  user-select: none;
  align-items: flex-start;
  margin-top: 8px;
  padding: 8px 0;
  padding-left: 24px;
  justify-content: flex-start;
  text-align: start;
  width: 100%;
  cursor: pointer;
  :hover {
    border-radius: 8px;
    background: ${beam.background.hover};
  }
`;
export const ShowOptions = styled.div<SearchProps>`
  display: flex;
  position: absolute;
  top: 40px;
  background: #fff;
  width: 100%;
  flex-direction: column;
  z-index: 9;
  border: ${({ haveResults }) => (haveResults ? '1px solid #e9edf1' : 'none')};
  border-top: none;
  border-radius: 0 0 8px 8px;
`;
export const Div = styled.div`
  position: relative;
  flex-direction: column;
  display: flex;
  height: 42px !important;

  .Close {
    position: absolute;
    right: 11px;
  }
`;
